// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3faHU","rootMobile":"styles_rootMobile__kRq3h"};